/**
 * Background refresh for lists that another device may have changed. Each poll re-reads
 * whole tables from D1, which bills (and on the free plan caps) by rows read; the app
 * also refetches whenever it regains focus, so a minute is plenty.
 */
export const BACKGROUND_REFETCH_MS = 60_000

export const queryKeys = {
  session: () => ['session'] as const,
  buckets: {
    list: (scope: 'active' | 'user' | 'archived' | 'system' = 'active') => ['buckets', scope] as const,
    activePriorityCount: (id: string) => ['buckets', id, 'active-priority-count'] as const,
  },
  priorities: {
    byBucket: (bucketId: string | undefined) => ['priorities', 'byBucket', bucketId] as const,
    detail: (id: string | null) => ['priorities', 'detail', id] as const,
    archived: () => ['priorities', 'archived'] as const,
    allActive: () => ['priorities', 'allActive'] as const,
    history: (id: string | null) => ['priorities', id, 'history'] as const,
  },
  journal: {
    entries: (search?: string, type?: string | null) => ['journal', 'entries', search ?? '', type ?? ''] as const,
    entry: (id: string | null) => ['journal', 'entry', id] as const,
    links: (journalId: string | null) => ['journal', journalId, 'links'] as const,
    bucketLinks: (journalId: string | null) => ['journal', journalId, 'bucket-links'] as const,
    linkCounts: () => ['journal', 'link-counts'] as const,
    lastWeeklyReview: () => ['journal', 'last-weekly-review'] as const,
    forPriority: (priorityId: string | null) => ['journal', 'for-priority', priorityId] as const,
    forBucket: (bucketId: string | null) => ['journal', 'for-bucket', bucketId] as const,
  },
  notes: {
    byPriority: (priorityId: string | null | undefined) => ['notes', 'byPriority', priorityId] as const,
    byBucket: (bucketId: string | null | undefined) => ['notes', 'byBucket', bucketId] as const,
  },
  valueTags: {
    all: () => ['valueTags'] as const,
    withCounts: () => ['valueTags', 'withCounts'] as const,
    forPriority: (priorityId: string) => ['valueTags', 'forPriority', priorityId] as const,
  },
  settings: () => ['settings'] as const,
  aiSummaries: {
    all: () => ['aiSummaries'] as const,
    latestInsights: () => ['aiSummaries', 'latestInsights'] as const,
    cached: (snapshotId: string) => ['aiSummaries', 'cached', snapshotId] as const,
  },
  allocation: (windowDays: number) => ['allocation', windowDays] as const,
  calendarAllocation: (from: string, to: string) => ['allocation', 'calendar', from, to] as const,
  search: (q: string, kind: string, dateRange: string, journalType: string | null) =>
    ['search', q, kind, dateRange, journalType] as const,
  coachingContext: () => ['coachingContext'] as const,
  coachingEstimate: (snapshotId: string | undefined, mode: string, includeFullJournal: boolean, model: string | undefined) =>
    ['coachingEstimate', snapshotId, mode, includeFullJournal, model] as const,
}
